import { useCallback } from 'react'
import _ from 'lodash'
import { useStore } from 'react-redux'
import { ContentStateInterface } from '../../@types/types'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { InitState } from '../../redux/reducers/root/initialState'
import { validateAndSaveInsertion } from '../../redux/thunks/insertionData/insertionData'
import { doAutoSaveDecider } from '../../redux/thunks/wizard/doAutoSaveDecider'
import { useIsSaved } from '../../redux/reducers/insertion/insertionFeature'
import {
  resetConstructionYearIfUnknown,
  resetConsumptionContainsWarmWaterIfNecessary,
  resetEnergyCertificateIfNotAvailable,
  resetPriceIfNecessary,
} from '../pages/insertionPage/insertionEditorValidators/Resets'

type InsertionDataUpdater = (oldData: ContentStateInterface) => ContentStateInterface

export function useApplyInsertionDataUpdate() {
  const dispatch = useAppDispatch()
  const store = useStore<InitState>()
  const isSaved = useAppSelector(useIsSaved)

  return useCallback(
    (updaterFunction: InsertionDataUpdater) => {
      const { insertionFeature, flowFeature } = store.getState()
      const currentInsertionData = insertionFeature.insertionData
      const newInsertionData = _.cloneDeep(updaterFunction(currentInsertionData))
      const flowInformation = flowFeature.flowInformation

      afterUpdateChecks(newInsertionData)
      if (_.isEqual(newInsertionData, currentInsertionData)) {
        return false
      }

      dispatch(validateAndSaveInsertion(newInsertionData, true))
      if (!isSaved) {
        dispatch(doAutoSaveDecider(flowInformation.validationSchema))
      }
      return true
    },
    [dispatch, isSaved, store]
  )
}

function afterUpdateChecks(insertionData: ContentStateInterface) {
  resetConsumptionContainsWarmWaterIfNecessary(insertionData, !insertionData.manualCountry)
  resetEnergyCertificateIfNotAvailable(insertionData)
  resetConstructionYearIfUnknown(insertionData)
  resetPriceIfNecessary(insertionData)
}

export type { InsertionDataUpdater }
